import { render, staticRenderFns } from "./reportInfo.vue?vue&type=template&id=44e2041f&scoped=true"
import script from "./reportInfo.vue?vue&type=script&lang=js"
export * from "./reportInfo.vue?vue&type=script&lang=js"
import style0 from "./reportInfo.vue?vue&type=style&index=0&id=44e2041f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2041f",
  null
  
)

export default component.exports